export default "__VITE_ASSET__DCmn4PUj__"